<template>
  <div>
    <!-- <el-button
      type="primary"
      icon="el-icon-plus"
      @click="setUserinfoDetailDialogVisible = true"
      >添加</el-button
    > -->
    <el-dialog
      :visible="userinfoDetailDialogVisible"
      title="修改信息"
      width="820px"
      @close="closeDialog"
    >
      <el-form :model="changeForm" ref="form"   label-width="160px">
        <el-form-item label="创建时间：">
          {{ changeForm.createTime }}
        </el-form-item>
        <el-form-item label="币种：">
          <el-input v-model="changeForm.coin" disabled></el-input>
        </el-form-item>
        <el-form-item label="id：">
          <el-input v-model="changeForm.id"></el-input>
        </el-form-item>
      
        <el-form-item label="完成状态：">
          <el-switch v-model="changeForm.isFinished"></el-switch>
        </el-form-item>
        <el-form-item label="内部状态：">
          <el-select v-model="changeForm.disposeStatusInner" >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'updatedialog',

  data() {
    return {
      changeForm: {
        id: '',
        tel: '',
        email: '',
        telCountryCode: '86'
      },
      statusOptions:[
        { value: 'SUCCESS', label: '成功' },
        { value: 'FAIL', label: '失败' },
        { value: 'EXECUTING_DISPOSE', label: '正在执行中' },
        { value: 'FAIL_CANNOT_RETRY ', label: '失败不能重试' },
        { value: 'REPEAT_CANNOT_RETRY', label: '重复不能重试' },
        { value: 'UNSUPPORTED_TRANSACTION', label: '不支持此交易' },
        { value: 'WAITING_FOR_CONFIRMATION', label: '等待确认中' },
      ],
      rules:{
        telCountryCode:[{required:true,message:'区号必选',trigger:blur}]
      }
      
      
    };
  },
  watch: {
    userinfoDetail(val, oldVal) {
      if (val !== oldVal) {
        this.changeForm = { ...val };
      }
    }
  },
  computed: {
    ...mapState('blockInfo', [
      'userinfoDetail',
      'userinfoDetailDialogVisible',
      'countryCodeList',
      'pagination',
    ]),
    ...mapGetters('blockInfo', ['userList'])
  },
  methods: {
    ...mapMutations('blockInfo', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    ...mapActions('blockInfo', ['updatInfo','list','resetPassword']),
    closeDialog() {
      this.setUserinfoDetailDialogVisible(false);
    },
    handleSave() {
      let updateInfo = {
        id: this.changeForm.id,
        disposeStatusInner: this.changeForm.disposeStatusInner,
        isFinished: this.changeForm.isFinished,
      
      };
      this.updatInfo(updateInfo).then(res=>{
        if(res.code==0){
          this.setUserinfoDetailDialogVisible(false);
           this.$message.success('修改成功')
        
        }
      });
    },
    resetLoginPassword(id){
      this.resetPassword({userId:id}).then(()=>{
        this.$message.success('重置成功！');
      })
    }
  },
  created() {
    // this.coutryCode();
  }
};
</script>

<style lang="less" scoped>
::v-deep.el-select {
  .el-input__inner {
    width: 100px;
  }
}
</style>
